export const APP_NAME = 'AviatorAnalytics';
export const APP_VERSION = '0.1.0';

/** Visible label so fixture rows cannot be mistaken for collector production data. */
export const SYNTHETIC_FIXTURE_ID = 'SYNTHETIC_FIXTURE_NOT_PRODUCTION';
export const ANALYTICS_CORE_FIXTURE_ID = 'SYNTHETIC_ANALYTICS_CORE_NOT_PRODUCTION';
export const SYNTHETIC_DATA_LABEL = 'SYNTHETIC DEVELOPMENT DATA';
export const REAL_SNAPSHOT_DATA_LABEL = 'REAL SNAPSHOT DATA';

export const RECOVERY_STATUSES = ['CONFIRMED', 'RECOVERED', 'UNCERTAIN'] as const;

export const NAV_ITEMS = [
  { to: '/', label: 'Overview' },
  { to: '/droughts', label: 'Droughts' },
  { to: '/profit', label: 'Profit Calculator' },
  { to: '/memory', label: 'Process Memory' },
  { to: '/auto-analyzer', label: 'Auto Analyzer' },
  { to: '/multipliers', label: 'Multipliers' },
  { to: '/paper', label: 'Paper Simulation' },
] as const;

export const MS_PER_HOUR = 3_600_000;
export const MS_PER_DAY = 86_400_000;

export const DROUGHT_ANALYTICS_TARGETS = [2, 3, 4, 5, 8, 10, 15, 20, 30, 40, 50, 100] as const;
export const DEFAULT_LONG_DROUGHT_THRESHOLD = 6;
export const LONG_DROUGHT_QUICK_THRESHOLDS = [6, 8, 10, 11] as const;

export const PROFIT_MATRIX_QUICK_TARGETS = [2, 3, 5, 10, 20, 50] as const;
export const MAX_PROFIT_MATRIX_CELLS = 5_000;
export const MAX_PROFIT_MATRIX_AXIS = 10_000;
export const DEFAULT_FIXED_STAKE = 1;

/** Analyzer-only ceiling. High enough for 100x / Max Games 100. Not the profit-matrix 5,000-cell cap. */
export const AUTO_ANALYZER_MAX_GAMES = 100;
/** Live Martingale safety: W is actual wager count. Analyzer does not silently rewrite user Max Games to this. */
export const AUTO_ANALYZER_MAX_MARTINGALE_GAMES = 12;
export const AUTO_ANALYZER_MAX_CELLS = 80_000;
